import { FC, useContext, useEffect, useState } from 'react';
import apiUrl from '../../assets/apiUrl';
import getIcon from '../../assets/extensionIcons';
import file from '../../common/file';
import { FileSystemContext } from '../FileSystem';
import { supportedFormats } from '../Viewer/PopupViewer';

interface Props {
  file: file;
  onDisplay: (file: file) => void;
  download: (file_uid: string, filename: string, size: number) => void;
}

const FileTitle: FC<Props> = ({ file, onDisplay, download }) => {
  const [isThumbnailFound, setIsThumbnailFound] = useState(false);
  const [thumbUrl, setThumbUrl] = useState('');
  const { useFilesMethods, useFiles, useFolders } =
    useContext(FileSystemContext);
  const { getThumbnail, getSignedUrl } = useFilesMethods();
  const [files] = useFiles();
  const [folders] = useFolders();
  const generateThumbnails = async () => {
    if (!isThumbnailFound && parseInt(file.size) <= 20000000) {
      const thumbnailFile = await getThumbnail(folders, files, file);
      if (!thumbnailFile) return;
      const thumbnailUrl = await getSignedUrl(
        `${apiUrl}/file?file_uid=${thumbnailFile.file_uid}`
      );
      setThumbUrl(thumbnailUrl);

      const cache = await caches.open('thumbnails');
      await cache.put(
        `${apiUrl}/file?filename=${file.file_uid}&folder_uid=${thumbnailFile.folder_uid}`,
        await fetch(
          await getSignedUrl(
            `${apiUrl}/file?file_uid=${thumbnailFile.file_uid}`
          )
        )
      );
    }
  };
  useEffect(() => {
    function findThumbnailFolderUid() {
      const folder = folders.filter((e) => e.title === '.thumbnails');
      if (folder.length === 0) return undefined;
      return folder[0].folder_uid;
    }
    async function getThumbnail() {
      const thumbnailFolder = findThumbnailFolderUid();
      if (!thumbnailFolder) return;
      const thumbnailUrl = `${apiUrl}/file?filename=${file.file_uid}&folder_uid=${thumbnailFolder}`;
      const cache = await caches.open('thumbnails');
      let response = await cache.match(thumbnailUrl);

      if (response === undefined) {
        try {
          await cache.put(
            thumbnailUrl,
            await fetch(await getSignedUrl(thumbnailUrl))
          );
          response = await cache.match(thumbnailUrl);
        } catch (error) {
          generateThumbnails();
          return;
        }
      }
      setThumbUrl(URL.createObjectURL(await response!.blob()));
    }
    getThumbnail();
    // eslint-disable-next-line
  }, [folders]);
  return (
    <div>
      <i
        className={`${getIcon(file.extension)} ${isThumbnailFound && 'hide'}`}
      />
      {thumbUrl !== '' && (
        <img
          className={`${!isThumbnailFound && 'hide'}`}
          alt={'thumbnail'}
          src={thumbUrl}
          onError={() => {
            setIsThumbnailFound(false);
            generateThumbnails();
          }}
          onLoad={() => setIsThumbnailFound(true)}
        />
      )}
      <span
        onClick={() => {
          supportedFormats.includes(file.extension) ||
          window.Protonfile.FileViewer.supportedFormats.get(file.extension)
            ? onDisplay(file)
            : download(file.file_uid, file.filename, parseInt(file.size));
        }}
      >
        {file.filename}
      </span>
    </div>
  );
};

export default FileTitle;
